import React from 'react';
import { Button, Tooltip } from 'antd';
import { containerIds } from '../../constants/containerIds';
import styles from './DeleteAndEditContainer.module.scss';

const getPopupContainer = () =>
  document.getElementById(containerIds.calendarGrid);

const buttonProps = {
  shape: 'circle',
  type: 'ghost',
};

const tooltipProps = {
  getPopupContainer,
  placement: 'bottom',
};

const buttons = [
  { tooltipTitle: 'Изменить время', icon: 'edit' },
  { tooltipTitle: 'Удалить из календаря', icon: 'delete' },
];

const DeleteAndEditContainer = ({ onDelete, onEdit, onExitEditState }) => {
  return (
    <div className={styles.root}>
      {buttons.map((btn) => (
        <Tooltip key={btn.icon} {...tooltipProps} title={btn.tooltipTitle}>
          <Button
            {...buttonProps}
            icon={btn.icon}
            onClick={btn.icon === 'edit' ? onEdit : onDelete}
          />
        </Tooltip>
      ))}
      {typeof onExitEditState === 'function' && (
        <Tooltip {...tooltipProps} title="Выйти из режима редактирования">
          <Button {...buttonProps} icon="logout" onClick={onExitEditState} />
        </Tooltip>
      )}
    </div>
  );
};

export default DeleteAndEditContainer;
